import * as types from "../../constants";
import * as api from "../../services/APIService";

const route = "api/Group/";

export function get() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_GROUP_PENDING });
    return api
      .get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_GROUP_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_GROUP_ERROR });
        throw error;
      });
  };
}

export function update(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_GROUP_PENDING });
    return api
      .update(route, value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_GROUP_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_GROUP_ERROR });
        throw error;
      });
  };
}

export function insert(value) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_GROUP_PENDING });
    return api
      .insert(route, value)
      .then((response) => {
        dispatch({
          type: types.INSERT_GROUP_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_GROUP_ERROR });
        throw error;
      });
  };
}

export function updateItem(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_GROUP_PENDING });
    return api
      .update(route, value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_GROUP_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_GROUP_ERROR });
        throw error;
      });
  };
}

export function insertItem(value) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_GROUP_PENDING });
    return api
      .insert(route, value)
      .then((response) => {
        dispatch({
          type: types.INSERT_GROUP_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_GROUP_ERROR });
        throw error;
      });
  };
}

export function deleteItem(value) {
  return async (dispatch) => {
    dispatch({ type: types.REMOVE_GROUP_PENDING });
    return (
      api
        .remove(route, value)
        .then((response) => {
          dispatch({
            type: types.REMOVE_GROUP_SUCCESS,
            payload: response,
          });
        })
        //.then(dispatch(get(route)))
        .catch((error) => {
          dispatch({ type: types.REMOVE_GROUP_ERROR });
          throw error;
        })
    );
  };
}

// export function remove(value) {
//   return async (dispatch) => {
//     dispatch({ type: types.REMOVE_GROUP_PENDING });
//     return api
//       .remove(route, value)
//       .then((response) => {
//         dispatch({
//           type: types.REMOVE_GROUP_SUCCESS,
//           payload: response,
//         });
//         dispatch(get());
//       })
//       .catch((error) => {
//         dispatch({ type: types.REMOVE_TASK_TEMPLATE_ERROR });
//         throw error;
//       });
//   };
// }
